import { render, staticRenderFns } from "./ActivitiesPane.vue?vue&type=template&id=5689a13a&scoped=true"
import script from "./ActivitiesPane.vue?vue&type=script&lang=js"
export * from "./ActivitiesPane.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesPane.vue?vue&type=style&index=0&id=5689a13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5689a13a",
  null
  
)

export default component.exports